<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="faq_mail_icon"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g id="Group_328" data-name="Group 328" transform="translate(2 3.333)">
      <path
        id="Path_7700"
        data-name="Path 7700"
        d="M11.254,10.145l3-2.037A1.7,1.7,0,0,0,15,6.7h0A1.7,1.7,0,0,0,13.3,5H4.716a1.7,1.7,0,0,0-1.7,1.7h0a1.7,1.7,0,0,0,.747,1.408l3,2.037a4,4,0,0,0,4.489,0Z"
        transform="translate(-3.005 -5)"
        fill="none"
        :stroke="clr ? clr : '#323232'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        id="Path_7701"
        data-name="Path 7701"
        d="M3,7.551v6.3a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2v-6.3"
        transform="translate(-3 -5.85)"
        fill="none"
        :stroke="clr ? clr : '#323232'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
    </g>
    <path id="Path_7702" data-name="Path 7702" d="M0,0H16V16H0Z" fill="none" />
  </svg>
</template>
